.strip {
  display: flex;
  flex-direction: row;
  padding: 0.8rem 1.6rem;
  gap: 0.8rem;
  flex-wrap: wrap;

  &:not(:last-child) {
    border-bottom: 0.1rem solid var(--color-surfaces-bg-elevation-2);
  }

  &:hover {
    cursor: pointer;
    background: var(--color-surfaces-bg-elevation-1);
  }
}

.priority {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
  border-radius: var(--border-radius-medium);
  height: 2.4rem;
  width: 2.4rem;
  justify-content: center;
  padding: 0;
  background-color: transparent;

  &:hover {
    background-color: var(--color-surfaces-bg-elevation-2);
  }

  &[data-disabled] {
    pointer-events: none;
    cursor: default;
  }
}

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
